import { Button } from '@salutejs/sdds-insol';
import { useModalStore } from '@/entities/Modal';
import { Typography } from '@/shared/ui/Typography';
import Logo from '@/shared/assets/lk/lkLogo.svg?react';
import { ModalWrapper } from '@/shared/ui/ModalWrapper';
import cls from './ErrorModal.module.scss';

export const ErrorModal = () => {
    const { errorModalProps, setErrorModalProps } = useModalStore();

    return (
        <ModalWrapper
            id="errorModal"
            isOpened={errorModalProps.isOpened}
            setIsOpened={(condition) => setErrorModalProps({ isOpened: condition, title: '' })}
        >
            <div className={cls.container}>
                <Logo className={cls.logo} />
                <Typography className={cls.title} as="h5" variant="h5_bold">
                    {errorModalProps.title}
                </Typography>
                <Button
                    size="xl"
                    type="submit"
                    view="accent-gradient"
                    stretch
                    onClick={() => {
                        setErrorModalProps({ isOpened: false, title: '' });
                    }}
                >
                    Понятно
                </Button>
            </div>
        </ModalWrapper>
    );
};
